import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, TitleStrategy } from '@angular/router';

import { PageTitleService } from './page-title.service';

/**
 * Usa o `title` da rota (portal) ou o `data.title` (sistema do escritório) da rota mais interna
 * e entrega ao PageTitleService, que completa com o nome do escritório.
 */
@Injectable()
export class BrandTitleStrategy extends TitleStrategy {
  private readonly pageTitle = inject(PageTitleService);

  override updateTitle(snapshot: RouterStateSnapshot): void {
    this.pageTitle.setPage(this.buildTitle(snapshot) ?? deepestDataTitle(snapshot.root));
  }
}

function deepestDataTitle(route: ActivatedRouteSnapshot): string | null {
  let current: ActivatedRouteSnapshot | null = route;
  let found: string | null = null;
  while (current) {
    const value = current.data?.['title'];
    if (typeof value === 'string' && value.trim()) found = value;
    current = current.firstChild;
  }
  return found;
}
